// Схема форм 1–6-аква (приказ МСХ РК № 403); подписи полей лежат в locales под ключом aqua.fields
export const AQUA_FORMS = [1, 2, 3, 4, 5, 6]

export const CHAPTERS = {
	5: ['cage', 'pond'],
	6: ['cage', 'republican', 'pond'],
}

export const OBLIGATION_COUNTS = { cage: 14, pond: 16 }

export const OBLIGATION_STATUSES = ['done', 'not_done', 'in_progress']

const text = (key, extra = {}) => ({ key, type: 'text', required: true, ...extra })
const optionalText = (key) => ({ key, type: 'text', required: false })
const number = (key, extra = {}) => ({ key, type: 'number', required: true, ...extra })
const integer = (key, extra = {}) => ({ key, type: 'integer', required: true, ...extra })
const fish = { key: 'fish_id', type: 'fish', required: true }
const chapter = { key: 'chapter', type: 'chapter', required: true }

const ROW_FIELDS = {
	1: [
		text('fishery_object_name'),
		fish,
		number('produced_volume_ton'),
		number('harvested_volume_ton'),
		number('sold_volume_ton'),
		number('sold_amount_kzt'),
		number('production_capacity_ton'),
		integer('farm_establishment_year'),
		number('planned_production_ton'),
		number('actual_production_ton'),
		text('stocking_material_source'),
		text('water_supply_source'),
		number('lake_farm_area_ha'),
		number('cage_farm_volume_m3'),
		number('uzv_pool_volume_m3'),
		number('pond_area_ha'),
		number('fry_cost_kzt'),
		number('feed_cost_kzt'),
		number('medicine_cost_kzt'),
		number('electricity_cost_kzt'),
		number('fertilizer_cost_kzt'),
		number('investment_cost_kzt'),
		number('average_salary_kzt'),
	],
	2: [
		text('water_object_name'),
		fish,
		number('feed_cost_previous_period_kzt'),
		optionalText('domestic_feed_supplier_name'),
		number('domestic_feed_volume_ton'),
		optionalText('imported_feed_country'),
		number('imported_feed_volume_ton'),
		optionalText('domestic_feed_used_name'),
		number('domestic_feed_used_volume_ton'),
		optionalText('imported_feed_used_name'),
		number('imported_feed_used_volume_ton'),
		number('feed_requirement_next_year_ton'),
	],
	3: [
		text('district_name'),
		text('city_village_name'),
		number('extruded_feed_volume_ton'),
		number('specialized_feed_volume_ton'),
		number('investment_amount_kzt'),
		number('enterprise_capacity_ton'),
		number('planned_production_volume_ton'),
		number('actual_production_volume_ton'),
		number('existing_financial_benefits_kzt'),
		number('planned_financial_benefits_kzt'),
	],
	4: [
		text('water_object_name'),
		text('fish_breed_name'),
		integer('purchased_breeding_stock_qty_prev_period'),
		number('breeding_stock_purchase_cost_kzt'),
		integer('breeding_stock_total_qty'),
		integer('breeding_stock_quality_evaluated_qty', { maxField: 'breeding_stock_total_qty' }),
		integer('breeding_stock_genomic_evaluated_qty', { maxField: 'breeding_stock_total_qty' }),
	],
	5: [chapter, text('water_object_name'), { key: 'obligations', type: 'obligations', required: true }],
	6: [
		chapter,
		text('water_object_name'),
		number('fish_production_plan_ton'),
		number('fish_production_fact_ton'),
		number('mto_cages_plan_kzt', { chapters: ['cage'] }),
		number('mto_feeders_plan_kzt', { chapters: ['cage'] }),
		number('mto_boats_plan_kzt', { chapters: ['cage'] }),
		number('mto_other_plan_kzt', { chapters: ['cage'] }),
		number('mto_plan_kzt', { chapters: ['republican'] }),
		number('mto_fact_kzt', { chapters: ['cage', 'republican'] }),
		number('construction_plan_kzt', { chapters: ['republican'] }),
		number('construction_fact_kzt', { chapters: ['republican'] }),
		text('species_name', { chapters: ['pond'] }),
		text('age_structure', { chapters: ['pond'] }),
		text('fish_replacement_activity', { chapters: ['pond'], type: 'textarea' }),
		integer('stocking_plan_qty', { chapters: ['pond'] }),
		integer('stocking_fact_qty', { chapters: ['pond'] }),
		text('reclamation_activity', { chapters: ['pond'], type: 'textarea' }),
	],
}

export const PERCENT_KEYS = ['production_percent', 'mto_percent', 'construction_percent', 'stocking_percent']

export function rowFields(form) {
	return ROW_FIELDS[form] || []
}

export function visibleRowFields(form, row) {
	return rowFields(form).filter((field) => !field.chapters || field.chapters.includes(row.chapter))
}

export function emptyObligations(chapterKey) {
	return new Array(OBLIGATION_COUNTS[chapterKey] || 0).fill(null)
}

export function emptyRow(form) {
	const row = {}
	rowFields(form).forEach((field) => {
		row[field.key] = null
	})
	if (CHAPTERS[form]) row.chapter = CHAPTERS[form][0]
	if (form === 5) row.obligations = emptyObligations(row.chapter)
	return row
}

export function isEmptyValue(value) {
	return value === null || value === undefined || value === ''
}

// Возвращает ключи незаполненных или некорректных полей строки, чтобы подсветить их до отправки
export function rowErrors(form, row) {
	const errors = {}
	visibleRowFields(form, row).forEach((field) => {
		const value = row[field.key]
		if (field.type === 'obligations') {
			if (!Array.isArray(value) || value.some((status) => !OBLIGATION_STATUSES.includes(status))) {
				errors[field.key] = true
			}
			return
		}
		if (field.required && isEmptyValue(value)) {
			errors[field.key] = true
			return
		}
		if ((field.type === 'number' || field.type === 'integer') && !isEmptyValue(value)) {
			const numeric = Number(value)
			const invalid =
				Number.isNaN(numeric) || numeric < 0 || (field.type === 'integer' && !Number.isInteger(numeric))
			const overMax = field.maxField && numeric > Number(row[field.maxField])
			if (invalid || overMax) errors[field.key] = true
		}
	})
	return errors
}

export const OBJECT_KEYS = ['fishery_object_name', 'water_object_name']

// Порядок и смысловые блоки полей строки только для отображения; состав полей задаёт ROW_FIELDS
const FIELD_GROUPS = {
	1: [
		{ key: 'object', fields: ['fishery_object_name', 'fish_id', 'farm_establishment_year'] },
		{ key: 'volumes', fields: ['produced_volume_ton', 'harvested_volume_ton', 'sold_volume_ton', 'sold_amount_kzt'] },
		{ key: 'plan', fields: ['production_capacity_ton', 'planned_production_ton', 'actual_production_ton'] },
		{
			key: 'farm',
			fields: [
				'stocking_material_source',
				'water_supply_source',
				'lake_farm_area_ha',
				'cage_farm_volume_m3',
				'uzv_pool_volume_m3',
				'pond_area_ha',
			],
		},
		{
			key: 'costs',
			fields: [
				'fry_cost_kzt',
				'feed_cost_kzt',
				'medicine_cost_kzt',
				'electricity_cost_kzt',
				'fertilizer_cost_kzt',
				'investment_cost_kzt',
				'average_salary_kzt',
			],
		},
	],
	2: [
		{ key: 'object', fields: ['water_object_name', 'fish_id', 'feed_cost_previous_period_kzt'] },
		{
			key: 'feed_bought',
			fields: ['domestic_feed_supplier_name', 'domestic_feed_volume_ton', 'imported_feed_country', 'imported_feed_volume_ton'],
		},
		{
			key: 'feed_used',
			fields: ['domestic_feed_used_name', 'domestic_feed_used_volume_ton', 'imported_feed_used_name', 'imported_feed_used_volume_ton'],
		},
		{ key: 'feed_need', fields: ['feed_requirement_next_year_ton'] },
	],
}

export function groupedRowFields(form, row) {
	const fields = visibleRowFields(form, row)
	const groups = FIELD_GROUPS[form]
	if (!groups) return [{ key: null, fields }]
	const byKey = Object.fromEntries(fields.map((field) => [field.key, field]))
	const grouped = groups
		.map((group) => ({ key: group.key, fields: group.fields.map((key) => byKey[key]).filter(Boolean) }))
		.filter((group) => group.fields.length)
	const used = new Set(groups.flatMap((group) => group.fields))
	const rest = fields.filter((field) => !used.has(field.key))
	return rest.length ? [...grouped, { key: null, fields: rest }] : grouped
}

export function aquaApiPrefix(scope, form) {
	return `v1/aqua/${scope}/${form}`
}
